import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    animations: [
        trigger('dialog', [
            transition('void => *', [style({ transform: 'scale3d(.3, .3, .3)' }), animate(100)]),
            transition('* => void', [animate(100, style({ transform: 'scale3d(.0, .0, .0)' }))]),
        ]),
    ],
    standalone: false
})
export class DialogComponent {
    @Input() closable: boolean = true;
    @Input() showCloseButton: boolean = false;
    @Input() visible: boolean;
    @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() cssClass: string;
    @Input() cssStyle: any;

    close() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
    }
}
